export  default {
    getPermAreas(state) {
        return state.permAreas;
    },
    getPermAreasByGroup(state, id) {
        return state.permAreas.find(x => x.groupId === id);
    },
};